import { Box, keyframes } from "@mui/material";
import RoomIcon from "@mui/icons-material/Room";

const pinBounce = keyframes`
  0%, 100% { transform: translate(-50%, -100%); }
  50% { transform: translate(-50%, calc(-100% - 8px)); }
`;

type MapCenterPinProps = {
  bounce?: boolean;
};

const MapCenterPin = ({ bounce = false }: MapCenterPinProps) => {
  return (
    <>
      <Box
        sx={{
          position: "absolute",
          bottom: "calc(50% - 6px)",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 98,
          width: 14,
          height: 5,
          borderRadius: "50%",
          bgcolor: "rgba(0, 0, 0, 0.2)",
          filter: "blur(1px)",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -100%)",
          zIndex: 99,
          pointerEvents: "none",
          animation: bounce ? `${pinBounce} 0.35s ease-out` : "none",
        }}
      >
        <RoomIcon
          sx={{
            fontSize: 44,
            color: "primary.main",
            display: "block",
            filter: "drop-shadow(0 3px 6px rgba(0, 0, 0, 0.35))",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: "29%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 12,
            height: 12,
            borderRadius: "50%",
            bgcolor: "#fff",
          }}
        />
      </Box>
    </>
  );
};

export default MapCenterPin;
